module.exports = __webpack_public_path__ + "img/yihurencai.ed6edc96.png";